import { render } from "./SleepingCourses.vue?vue&type=template&id=305b57f5&scoped=true"
import script from "./SleepingCourses.vue?vue&type=script&lang=js"
export * from "./SleepingCourses.vue?vue&type=script&lang=js"

import "./SleepingCourses.vue?vue&type=style&index=0&id=305b57f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305b57f5"]])

export default __exports__